<template>
	<div class="template_input">
		<label v-bind:for="params.name">{{getLabel(params.label)}} <span v-if="params.compulsory" class="star">*</span>:</label>
		<input type="number" v-bind:id="params.name" v-bind:placeholder="getLabel(params.label)" onkeydown="javascript: return event.keyCode == 69 ? false : true" v-model="value" step="1" min="1" pattern="\d*">
	</div>
</template>

<script>

import componentTools from '@/libs/componentTools.js';

export default {
	name: 'number_input',
	data() {
		return {
			value : ''
		}
	},
	props : ['params', 'oldValue', 'lang'],
	computed : {
	},
	methods : {
		validate : function(v) {
			return v.trim().length;
		},
		notifyUpdate : function(val) {
			this.$emit('validateField', this.params.name, val);
		},
		getLabel : componentTools.getLabel
	},
	watch: {
		value : function(val){
			this.notifyUpdate(val);
		},
		oldValue : function(val){
			if(!val) this.value = '';
		}
	},
	mounted : function(){
		if(this.oldValue) this.value = this.oldValue;
		else this.value = '';
	}
};
</script>



// WEBPACK FOOTER //
// src/components/candidate_forms/number_input.vue